import { render, staticRenderFns } from "./MetaFaturamento.vue?vue&type=template&id=a3aba0c4&scoped=true"
import script from "./MetaFaturamento.vue?vue&type=script&lang=js"
export * from "./MetaFaturamento.vue?vue&type=script&lang=js"
import style0 from "./MetaFaturamento.vue?vue&type=style&index=0&id=a3aba0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aba0c4",
  null
  
)

export default component.exports